module.exports = __webpack_public_path__ + "static/media/valve.6adac7d4.svg";